<template>
    <vCommodityFlowAdjustmentList :postList="postList" v-if="flag"></vCommodityFlowAdjustmentList>
</template>
<script>
import vCommodityFlowAdjustmentList from '../../listComponent/basicdata/commodityFlowAdjustment/commodityFlowAdjustmentComponent.vue';
export default {
    name: 'commodityFlowAdjustmentList',
    components: {
        vCommodityFlowAdjustmentList
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>